<template>

  <!--<loading v-show="showLoading"></loading>-->

  <div class="buy_physical_content">

    <div class="physical_list_content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="physical_list_content_each boxshadow" :class="[index%2==0?'physical_each_margin':'']" v-for="(goods,index) in productList" :key="index" @click="goCardDetail(goods.productId)">
          <div class="physical_list_content_each_image">
            <van-image fit="cover" :src="goods.imageUrl"/>
          </div>
          <div class="physical_list_content_bottom">
            <div class="physical_list_content_name zt12">
              {{goods.productName}}
            </div>
            <div class="physical_list_content_price">
              ¥{{goods.price}}
            </div>
          </div>
        </div>

        <div class="cart_content" v-if="emptyList">
          <p class="tc grey zt14" style="padding: 2rem 0">暂无可售商品信息</p>
        </div>
        <refresh class="fl full_w" style="position:relative;-webkit-overflow-scrolling : touch;overflow:auto;margin-bottom:45px;" @zj-load="loadMore" :lastPage='{total: !allLoaded, empty: productList.length,show:show}'></refresh>
      </van-pull-refresh>

    </div>

  </div>
</template>

<script>


  import Vue from 'vue';
  import { storeName,prodCatalogId,shareCardUrl,wxUrl } from '@/router/Constant'
  import { getCardList,login } from '@/router/api';
  import { NavBar,Image,Tabbar,DropdownMenu,DropdownItem,SwitchCell,Button } from 'vant';
  import { Search,Overlay,List,PullRefresh,Toast } from 'vant';
  import { setStore,getStore,getCookie,setCookie,GetQueryString,setMiniProgramShare } from '@/utils/mUtil';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';


  export default {
    name: "physicalphysicalList",
    data(){
      return {
        productList:[],
        token:getStore('externalLoginKey'),
        productCategoryId:'',
        viewIndex:0,  //default 0
        viewSize:20,
        orderBy:"",
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        show: false,
        allLoaded: false,
        isLoading:false,
        showLoading:true,
        listSize:[],
        emptyList:false
      }
    },

    components: {
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Tabbar.name]: Tabbar,
      [Search.name]: Search,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
      [SwitchCell.name]: SwitchCell,
      [Button.name]: Button,
      [Overlay.name]: Overlay,
      [List.name]: List,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      footerView,
      loading,
      refresh
    },

    mounted() {
      this.initData()
    },

    methods:{

      async initData() {

        this.getGiftList();
        setMiniProgramShare('购买卡币礼品卡','',wxUrl+encodeURIComponent(shareCardUrl))
      },


      // //判断是否是小程序环境
      // doMiniProgram:function (callback) {
      //   console.log('判断环境')
      //   try {
      //     //小程序环境设置分享
      //     var ua = window.navigator.userAgent.toLowerCase();
      //     //判断是否是微信环境
      //     if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      //       //微信环境
      //       wx.miniProgram.getEnv(function (res) {
      //         if (res.miniprogram) {
      //           callback();
      //         }
      //       })
      //     }
      //   }
      //   catch (ex) {
      //     console.log(ex);
      //   }
      // },
      //
      // //设置小程序分享
      // setMiniProgramShare:function (shareTitle, imageUrl, shareUrl) {
      //   console.log('设置')
      //   try {
      //     this.doMiniProgram(function () {
      //       // 小程序环境下逻辑
      //       console.log('小程序环境')
      //       wx.miniProgram.postMessage({ data: { title: shareTitle, path: shareUrl, imageUrl: imageUrl } })
      //     })
      //     // doMiniProgram(function () {
      //     //
      //     // });
      //   }
      //   catch (ex) {
      //     console.log(ex);
      //   }
      // },


      //获取实体卡列表
      getGiftList:function () {
        var param = {
          productCategoryId:'PhysicalCardRoot',
          viewIndex:this.viewIndex,
          viewSize:this.viewSize,
          productStoreId:this.productStoreId,
          prodCatalogId:prodCatalogId
        }
        getCardList(param)
          .then(res => {
            console.log(res);
            console.log("getCardList")
            if (res.productList) {
              if (res.productList.length == 0){
                this.emptyList = true
              } else {
                this.emptyList = false
              }
              this.productList = res.productList;

              this.viewIndex = res.viewIndex;
              this.viewSize = res.viewSize;
              this.listSize = res.listSize;

              if (res.listSize == 0){
                Toast('未搜索到您想要的宝贝')
              }

              setTimeout(() => {
                this.showLoading = false;
              }, 1000);
              if (this.productList.length < res.listSize) {
                this.allLoaded = false
                this.show = true
              }
              console.log(this.productList.length,this.show)

            } else {
              Toast("未搜索到您想要的宝贝");
            }
          })
          .catch(err => {
            console.log(err);
          });

      },

      //下拉刷新
      onRefresh() {
        // if (this.allLoaded != true) {
        setStore('onRefresh',"onRefresh")
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        // }
      },

      //上拉加载
      loadMore() {
        if (!this.allLoaded) {
          this.viewIndex ++;
          var param = {
            productCategoryId:'PhysicalCardRoot',
            viewIndex:this.viewIndex,
            viewSize:this.viewSize,
            productStoreId:this.productStoreId,
            prodCatalogId:prodCatalogId
          }
          getCardList(param)
            .then(res => {
              console.log(res)
              if (res.productList) {
                this.show = true
                if (res.productList.length < this.viewSize) {
                  this.allLoaded = true
                } else {
                  this.allLoaded = false
                }
                var oldProductList = this.productList
                var newProductList = oldProductList.concat(res.productList)
                this.productList = newProductList
                this.viewIndex = res.viewIndex;
              } else {
                Toast("未搜索到您想要的宝贝");
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      },


      goCardDetail:function (productId) {
        this.$router.push({path:'/physicalCardDetail',query:{goodsId:productId}})
      }


    }
  }
</script>

<style>

  .buy_physical_content{
    width:21.875rem;
    margin: 0.625rem auto;
  }

  .physical_list_content{
    width:100%;
  }
  .physical_list_content_each{
    display: inline-block;
    vertical-align: top;
    width:10.5rem;
    border-radius: 0.625rem;
    margin-bottom: 0.625rem;
  }
  .physical_each_margin{
    margin-right: 0.7rem;
  }
  .physical_list_content_each_image{
    width:100%;
    height: 9.275rem;
  }
  .physical_list_content_each_image .van-image{
    width:100%;
    height: 100%;
    border-top-left-radius: 0.625rem;
    border-top-right-radius: 0.625rem;
  }
  .physical_list_content_bottom{
    padding: 0.625rem;
  }
  .physical_list_content_name{
    color:#4A4A4A;
    height: 1rem;
    line-height: 1rem;

  }
  .physical_list_content_price{
    font-size: 0.75rem;
    color:#FF0000;
    height:1rem;
    line-height:1rem;
    font-weight: bold;
    margin-top: 0.3rem;
    text-align: right;
  }

  .boxshadow {
    box-shadow: -1px 2px 5px 2px #e0e0e0;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/cardCurrency/physicalCardList.vue